import { useState } from 'react';
import { motion } from 'motion/react';

function RoundButton({ children, index, color, onClick }) {
  const [pressed, setPressed] = useState(false);
  const [initialAnimationDone, setInitialAnimationDone] = useState(false);

  
  const glowVariants = {
    hidden: { opacity: 0 },
    initial: { opacity: 0.5 },
    pressed: { opacity: 1 },
  };

  // Usamos una transición con delay y duración para la animación inicial;
  // una vez completada, los cambios de estado usan 0 delay y 0.3s de duración.
  const transition = initialAnimationDone
    ? { duration: 0.3, delay: 0 }
    : { duration: 0.6, delay: (index * 0.5) + 0.4 };

  return (
    <div
      onClick={onClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      className="transform-gpu w-[45.375rem] h-[45.375rem] rounded-full flex relative"
    >
      {/* Capa de fondo */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: (index * 0.5) + 0.2 }}
        className={`
          absolute
          rounded-full
          bg-gradient-${color}
          top-0 left-0 w-full h-full
          p-[0.25rem]
          after:content-['']
          after:w-full after:h-full after:rounded-full after:block after:bg-[#061933]
          rotating
        `}
      />

      {/* Capa con glow */}
      <motion.div
        variants={glowVariants}
        initial="hidden"
        // Si se presiona, se anima al estado "pressed"; de lo contrario, al estado "initial"
        animate={pressed ? 'pressed' : 'initial'}
        transition={transition}
        // Al completarse la animación, si se terminó en "initial", marcamos que la animación inicial ha finalizado.
        onAnimationComplete={(variant) => {
          if (variant === 'initial' && !initialAnimationDone) {
            setInitialAnimationDone(true);
          }
        }}
        className={`
          absolute
          rounded-full
          bg-gradient-${color}2
          top-[5%] left-[5%]
          w-[90%] h-[90%]
          p-[1.25rem]
          after:content-['']
          after:w-full after:h-full after:rounded-full after:block after:bg-[#0B1931]
          blur-md rotating
        `}
      />

      {/* Capa central estática */}
      <div
        className="
          absolute
          rounded-full
          top-1/2 left-1/2
          -translate-x-1/2 -translate-y-1/2
          w-[85%] h-[85%]
          bg-[#061933]
        "
      />

      {/* Contenido con animación de aparición */}
      <motion.div
        initial={{ opacity: 0, filter: "blur(10px)" }}
        animate={{ opacity: 1, filter: "blur(0px)" }}
        transition={{ duration: 0.5, delay: index * 0.5 }}
        style={{ zIndex: 1 }}
        className='w-full'
      >
        {children}
      </motion.div>
    </div>
  );
}

export default RoundButton;